import smallWarning from "../assets/svg/small-warning.svg";
import { StyledErrorMessage } from "../DropzoneField/styles";
import { useTranslation } from "react-i18next";

interface ErrorProps {
  text: string;
  fontWeight?: string;
}

const Error = ({ text, fontWeight = "bold" }: ErrorProps) => {
  const { t } = useTranslation();
  return (
    <>
      <img alt={t("core:common:warning") as string} src={smallWarning} />
      <StyledErrorMessage fontWeight={fontWeight}> {text}</StyledErrorMessage>
    </>
  );
};

export default Error;
